import React, { useState } from "react";
import { Flex, Image } from "@chakra-ui/react";
import { Text } from "@foleon/atomic";
import SmileyIcon from "../icons/Smiley";
import { useParams } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import Form from "./Form";
import { writeDocReviewNew } from "../../../utils/services/surveyService";

const SAD = 1;
const NEUTRAL = 2;
const HAPPY = 3;

const NOT_REVIEWED = -1;

export const SurveyContainer = () => {
	const [currentValue, setCurrentValue] = useState(NOT_REVIEWED);
	const [smileySelected, setSmileySelected] = useState(false);
	const [values, setValues] = useState<string[]>([]);
	const [inputValue, setInputValue] = useState<string>();
	const [finished, setFinished] = useState(false);

	const params = useParams();

	const saveReview = (review: number) => {
		if (smileySelected) return;
		setSmileySelected(true);
		setCurrentValue(review);
		// if (docId && name) writeDocReview(uniqueID, +docId, name, review);
	};

	const saveInFirebase = () => {
		const uniqueID = uuidv4();
		const docId = params["publicationId"];
		const name = params["name"];
		console.log(values);

		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		writeDocReviewNew(uniqueID, +docId!, name!, currentValue, values, inputValue);
		setFinished(true);
		setSmileySelected(false);
	};

	return (
		<Flex
			direction="column"
			alignItems="center"
			gap="24px"
			pt="8px"
			pb="8px"
		>
			<Flex
				justifyContent="space-between"
				alignItems="center"
				gap="16px"
			>
				{smileySelected &&
					<Image src={`${process.env.PUBLIC_URL}/back-arrow.svg`}
						   h="28px"
						   onClick={() => {
							   setSmileySelected(false);
							   setValues([]);
						   }}
						   cursor="pointer"
						   _hover={{ transform: "scale(1.08)" }}
					>
					</Image>}
				{!finished && <Text.Title style={{ marginBottom: "0px", textAlign: "center" }}>
					{smileySelected
						? "Why did you choose this rating?"
						: "How would you rate the content experience?"}
				</Text.Title>}
			</Flex>

			{!smileySelected && !finished && <Flex
				direction="row"
				justifyContent="center"
				flexWrap="wrap"
				gap={{ base: "10px", sm: "20px" }}
			>
				<SmileyIcon
					isSelected={smileySelected}
					smileyValue={SAD}
					currentValue={currentValue}
					saveReview={saveReview}
					src="sad.svg"
					alt="mad"
				/>

				<SmileyIcon
					isSelected={smileySelected}
					smileyValue={NEUTRAL}
					currentValue={currentValue}
					saveReview={saveReview}
					src="neutral.svg"
					alt="Neutral Smiley"
				/>

				<SmileyIcon
					isSelected={smileySelected}
					smileyValue={HAPPY}
					currentValue={currentValue}
					saveReview={saveReview}
					src="happy.svg"
					alt="Mega Happy Smiley"
				/>
			</Flex>

			}
			{smileySelected && !finished && <Flex
				direction="row"
				justifyContent="center"
				flexWrap="wrap"
				gap={{ base: "10px", sm: "20px" }}
			>
				<Form selectedSmiley={currentValue} values={values} setValues={setValues}
					  inputValue={inputValue} setInputValue={setInputValue}
					  saveInFirebase={saveInFirebase}/>
			</Flex>
			}

			{finished && <Text.Title style={{ marginBottom: "0px", textAlign: "center" }}>
				Thanks for your input!
			</Text.Title>}
		</Flex>
	);
};

export default SurveyContainer;
